import React from 'react';
import { Formik, FormikHelpers } from 'formik';
import { CredentialsFormValues } from './types';
import { credentialsSchema } from './schemas';

type Props = {
  onSubmit: (
    values: CredentialsFormValues,
    helpers: FormikHelpers<CredentialsFormValues>
  ) => void;
  children: React.ReactNode;
};

export function CredentialsForm({ onSubmit, children }: Readonly<Props>) {
  return (
    <Formik<CredentialsFormValues>
      initialValues={{ firstName: '', phone: '', email: '' }}
      validationSchema={credentialsSchema}
      validateOnMount
      onSubmit={onSubmit}
    >
      {children}
    </Formik>
  );
}
